import { TableColumn } from "./dataInterface";

export const tossUpTableColumn: TableColumn = {
  title: "トスアップ一覧",
  detail: true,
  detailTitle: "トスアップ詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "トスアップ",
  editAuth: [
    "マスターアカウント",
    "スタッフアカウント",
    "パートナー",
    "営業アカウント",
  ],
  tableFunction: [
    {
      name: "クロージング",
      width: "85px",
      auth: ["パートナー", "営業アカウント"],
    },
    {
      name: "トスアップ複製",
      width: "100px",
      auth: ["パートナー", "営業アカウント"],
    },
    {
      name: "トスアップ取消",
      width: "100px",
      auth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
    },
  ],
  postCSVTitle: "",
  dataColumn: [],
  subTable: [
    {
      subTableAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "カテゴリー一覧",
      subTableColumnLength: "category_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "100px",
      subTableDetail: false,
      subTableDetailTitle: "カテゴリー詳細",
      subTableAdd: false,
      subTableAddTitle: "カテゴリー追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: false,
      subTableEditTitle: "カテゴリー編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "category_name",
          name: "カテゴリー名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "商材一覧",
      subTableColumnLength: "product_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "150px",
      subTableDetail: false,
      subTableDetailTitle: "商材詳細",
      subTableAdd: false,
      subTableAddTitle: "商材追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: false,
      subTableEditTitle: "商材編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [],
      subDataColumn: [
        {
          key: "product_name",
          name: "商材名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "顧客情報一覧",
      subTableColumnLength: "customer_info_length",
      detailKey: ["id"],
      subTableColumnNameWidth: "100px",
      subTableDetail: false,
      subTableDetailTitle: "顧客情報詳細",
      subTableAdd: false,
      subTableAddTitle: "顧客情報追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: false,
      subTableEditTitle: "顧客情報編集",
      subTableEditDirect: true,
      subTableEditDirectKey: "customer_info_value",
      subTableEditAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      tableFunction: [],
      subDataColumn: [
        {
          key: "customer_info_key",
          name: "質問名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "customer_info_value",
          name: "顧客情報",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
    {
      subTableAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      mainTableDetail: false,
      mainTableDetailColumn: "",
      subTableColumnName: "トスアップ情報一覧",
      subTableColumnLength: "toss_up_length",
      detailKey: ["toss_up_key"],
      subTableColumnNameWidth: "130px",
      subTableDetail: false,
      subTableDetailTitle: "トスアップ情報詳細",
      subTableAdd: false,
      subTableAddTitle: "トスアップ情報追加",
      subTableAddTitleWidth: "160px",
      subTableEdit: false,
      subTableEditTitle: "トスアップ情報編集",
      subTableEditDirect: false,
      subTableEditDirectKey: "",
      subTableEditAuth: [],
      tableFunction: [
        { name: "削除", auth: ["マスターアカウント", "スタッフアカウント"] },
      ],
      subDataColumn: [
        {
          key: "toss_up_key",
          name: "項目名",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
        {
          key: "toss_up_value",
          name: "トスアップ情報",
          table: true,
          tableValue: "text",
          detail: false,
          edit: false,
          editType: null,
          editId: "id",
          add: false,
          addType: "text",
          addMessage: "",
        },
      ],
      subTable: [],
    },
  ],
};
